import {Component, inject} from '@angular/core';
import {AUTOCOMPLETE_SEARCH, FormUI, IApplication, Pagination, TableUI, UIDef} from '@easy-cms'
import {RouterLink, RouterLinkActive, RouterOutlet} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {lastValueFrom, of} from "rxjs";
import {environment} from "../../../../environments/environment";
import {ConfigIconComponent, IconDirective, MessagesIconComponent} from "@icons";
import {UsersIconComponent} from "../../../components/icons/users-icon/users-icon.component";
import {EditorialsIconComponent} from "../../../components/icons/editorials-icon/editorials-icon.component";
import {PapersIconComponent} from "../../../components/icons/papers-icon/papers-icon.component";

@Component({
  selector: 'wun-layout',
  imports: [
    RouterLink,
    RouterOutlet,
    RouterLinkActive,
    ConfigIconComponent,
    UsersIconComponent,
    IconDirective,
    EditorialsIconComponent,
    PapersIconComponent,
    MessagesIconComponent,
  ],
  providers: [
    {
      provide: 'COMPONENTS',
      useValue: {}
    },
    {
      provide: 'CONFIGURATION',
      deps: [HttpClient],
      useFactory: (httpClient: HttpClient) => () => {
        const httpClient = inject(HttpClient);
        return httpClient
          .get<UIDef>(environment.baseUrl + '/configurations')
      }
    },
    {
      provide: 'DATA_MAPPER',
      deps: [HttpClient],
      useFactory: (httpClient: HttpClient) => (table: TableUI, application: IApplication, pagination: Pagination, search?: string, filters?: Record<string, any>, sorting?: Record<string, any>) => {
        const params = {
          $or: table.columns.filter(x => x.filterable).map(d => {
            return {
              [d.name!]: {$like: `%${search}%`}
            };
          })
        };
        const _sort = Object.entries(sorting || {}).reduce((dict, entry) => {
          dict[entry[0]] = entry[1] === 0 ? 'ASC' : 'DESC';
          return dict;
        }, {} as Record<string, 'ASC' | 'DESC'>);
        return httpClient.get(environment.baseUrl + '/' + table.endpoint!, {
          params: {
            pageSize: pagination.pageSize,
            page: pagination.page,
            filters: JSON.stringify(params),
            sorting: JSON.stringify(_sort),
            includes: JSON.stringify(table?.meta?.['includes'] || [])
          }
        });
      }
    },
    {
      provide: 'DELETE',
      deps: [HttpClient],
      useFactory: (httpClient: HttpClient) => (table: TableUI, application: IApplication, item: any, id: any) => {
        return httpClient.delete(application.endpoint + '/' + table.endpoint! + '/' + id);
      }
    },
    {
      provide: 'UPDATE',
      deps: [HttpClient],
      useFactory: (httpClient: HttpClient) => (form: FormUI, application: IApplication, item: any, id: any) => {
        if (form.method === 'PATCH') {
          return httpClient.patch(application.endpoint + '/' + form.action! + '/' + id, item);
        }
        return of();
      }
    },
    {
      provide: 'CREATE',
      deps: [HttpClient],
      useFactory: (httpClient: HttpClient) => (form: FormUI, application: IApplication, item: any) => {
        if (form.method === 'POST') {
          return httpClient.post(application.endpoint + '/' + form.action!, item);
        }
        return of();
      }
    },
    {
      provide: AUTOCOMPLETE_SEARCH,
      deps: [HttpClient],
      useFactory: (httpClient: HttpClient) => async (endpoint: string, str: string, filteringKeys: string[], displayKeys: string[], identifier: string, value?: any | undefined) => {
        const httpParams: Record<string, any> = {};
        const filters = filteringKeys.map(x => {
          return {
            [x]: {$ilike: `%${str}%`}
          };
        });
        if (value && !Array.isArray(value[identifier]))
          filters.push({[identifier]: value[identifier]});
        const d = await lastValueFrom(httpClient.get<{
          data: any;
        }>(endpoint, {
          params: {
            filters: JSON.stringify(filters),
          }
        }));
        return d.data;
      }
    },
    {
      provide: 'DEFAULT_ROW_CLASS',
      useValue: 'form-row'
    }
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent {
  pagination: Pagination = {
    page: 0,
    pageSize: 50
  };

}
